"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateNameFromCode = exports.getStateCodeFromName = exports.MALAYSIA_STATES = void 0;
var date_fns_1 = require("date-fns");
// List of Malaysian states as a constant
exports.MALAYSIA_STATES = [
    { Code: "01", State: "Johor" },
    { Code: "02", State: "Kedah" },
    { Code: "03", State: "Kelantan" },
    { Code: "04", State: "Melaka" },
    { Code: "05", State: "Negeri Sembilan" },
    { Code: "06", State: "Pahang" },
    { Code: "07", State: "Pulau Pinang" },
    { Code: "08", State: "Perak" },
    { Code: "09", State: "Perlis" },
    { Code: "10", State: "Selangor" },
    { Code: "11", State: "Terengganu" },
    { Code: "12", State: "Sabah" },
    { Code: "13", State: "Sarawak" },
    { Code: "14", State: "Wilayah Persekutuan Kuala Lumpur" },
    { Code: "15", State: "Wilayah Persekutuan Labuan" },
    { Code: "16", State: "Wilayah Persekutuan Putrajaya" },
    { Code: "17", State: "Not Applicable" }
];
// Helper functions for state code conversion
var getStateCodeFromName = function (stateName) {
    var stateObject = exports.MALAYSIA_STATES.find(function (state) { return state.State === stateName; });
    return stateObject ? stateObject.Code : "";
};
exports.getStateCodeFromName = getStateCodeFromName;
var getStateNameFromCode = function (stateCode) {
    var stateObject = exports.MALAYSIA_STATES.find(function (state) { return state.Code === stateCode; });
    return stateObject ? stateObject.State : "";
};
exports.getStateNameFromCode = getStateNameFromCode;
var EInvoiceProfile = /** @class */ (function () {
    function EInvoiceProfile(json) {
        this.id = json.id;
        this.merchantId = json.merchantId;
        this.name = json.name;
        this.tin = json.tin;
        this.identificationNumber = json.identificationNumber;
        this.identificationType = json.identificationType;
        this.sstNumber = json.sstNumber;
        this.msicCode = json.msicCode;
        this.businessActivityDescription = json.businessActivityDescription;
        this.contactNumber = json.contactNumber;
        this.emailAddress = json.emailAddress;
        this.addressLine1 = json.addressLine1;
        this.addressLine2 = json.addressLine2;
        this.addressLine3 = json.addressLine3;
        this.postcode = json.postcode;
        this.city = json.city;
        this.state = json.state;
        this.country = json.country;
        this.createdAt = new Date(json.createdAt);
        this.updatedAt = json.updatedAt ? new Date(json.updatedAt) : null;
    }
    Object.defineProperty(EInvoiceProfile.prototype, "formattedCreatedAt", {
        // Helper method to format createdAt for display
        get: function () {
            return (0, date_fns_1.formatISO)(this.createdAt);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EInvoiceProfile.prototype, "formattedUpdatedAt", {
        // Helper method to format updatedAt for display
        get: function () {
            return this.updatedAt ? (0, date_fns_1.formatISO)(this.updatedAt) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EInvoiceProfile.prototype, "stateName", {
        // Helper method to get state name from code
        get: function () {
            return (0, exports.getStateNameFromCode)(this.state);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EInvoiceProfile.prototype, Symbol.toStringTag, {
        get: function () {
            return 'EInvoiceProfile';
        },
        enumerable: false,
        configurable: true
    });
    return EInvoiceProfile;
}());
exports.default = EInvoiceProfile;
